/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Consent_PrefixInputs */

const en_checkout_consent_prefix = /** @type {(inputs: Checkout_Consent_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I accept the`)
};

/**
* | output |
* | --- |
* | "I accept the" |
*
* @param {Checkout_Consent_PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_consent_prefix = /** @type {((inputs?: Checkout_Consent_PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Consent_PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_consent_prefix(inputs)
});